import React from 'react';
import { Stack } from '@qred/components-library';
import SelectPaymentMethod from './components/SelectPaymentMethod';
import { useLoanOfferSelectors } from '~/store/selectors/loanOffer.selector';
import SelectPayoutAccount from './components/SelectPayoutAccount';

const BankInformation = () => {
  const { hasSepaDirectDebitFeature } = useLoanOfferSelectors();

  return (
    <Stack spacing={'xxl'}>
      <SelectPayoutAccount />

      {hasSepaDirectDebitFeature && <SelectPaymentMethod />}
    </Stack>
  );
};

export default BankInformation;
